import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Github(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-5.522 0-10 4.36-10 9.74 0 4.304 2.866 7.956 6.839 9.243.5.09.684-.211.684-.469 0-.232-.01-1-.014-1.813-2.783.59-3.37-1.15-3.37-1.15-.455-1.125-1.11-1.425-1.11-1.425-.907-.604.07-.592.07-.592 1.003.069 1.532 1.004 1.532 1.004.891 1.489 2.339 1.058 2.91.81.089-.63.348-1.06.635-1.303-2.222-.246-4.557-1.082-4.557-4.814 0-1.063.391-1.932 1.031-2.615-.104-.245-.446-1.236.097-2.577 0 0 .84-.262 2.75.998a9.835 9.835 0 012.504-.328c.849.004 1.705.112 2.505.328 1.908-1.26 2.747-.998 2.747-.998.544 1.341.201 2.332.098 2.577a3.708 3.708 0 011.029 2.615c0 3.741-2.34 4.565-4.566 4.806.358.303.678.895.678 1.804 0 1.304-.012 2.353-.012 2.673 0 .26.18.564.687.468 3.971-1.29 6.833-4.94 6.833-9.241C22 6.86 17.523 2.5 12 2.5z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Github);
export default ForwardRef;